import styles from "./Tooltip.module.scss";
import { OverlayTrigger, Tooltip } from "../DependencyHelper";
import { componentCheckSize } from "../../../utils/helperServices";
import config from "../../../config/index";
const env = config.env;
const imagePrefix = config.envConfigs[env].imagePrefix;

const TooltipContainer = ({ children, text }) => {
  const isMobile = componentCheckSize() < 576;
  return (
    <OverlayTrigger
      trigger={["hover", "click"]}
      placement={isMobile ? "top" : "right"}
      overlay={
        <Tooltip id={`tooltip-right`} className={styles.tooltipContainer}>
          {children}
        </Tooltip>
      }
    >
      {text ? (
        <span className={styles.textStyle}>{text}</span>
      ) : (
        <img
          className={styles.toolTipIcon}
          src={`${imagePrefix}/assets/images/toolTip-icon.svg`}
        />
      )}
    </OverlayTrigger>
  );
};

export default TooltipContainer;
